"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.comData = void 0;
exports.createCouponSkuRules = createCouponSkuRules;
exports.formConfig = void 0;
exports.getBrandList = getBrandList;
exports.getBrandLists = getBrandLists;
exports.getFuCardList = getFuCardList;
exports.getRule = getRule;
exports.getShippingList = getShippingList;
exports.getSupplierList = getSupplierList;
exports.init = init;
exports.rules = exports.props = void 0;
exports.validate = validate;
var _vue = _interopRequireDefault(require("vue"));
var _store = require("@/api/store");
var _componentsApi = require("@/api/componentsApi");
var _logistics = require("@/api/logistics");
var _api = require("./api");
var _fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi"));
var fudouActiveApi = _fudouActiveApi;
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var formConfig = exports.formConfig = {
  'label-width': '120px',
  'label-position': 'right'
};
var rules = exports.rules = {
  storeName: [{
    required: true,
    message: '请输入商品名称',
    trigger: 'blur'
  }],
  cateIds: [{
    required: true,
    message: '请选择商品分类',
    trigger: 'change'
  }],
  showCateId: [{
    required: true,
    message: '请选择展示分类',
    trigger: 'change'
  }],
  keyword: [{
    required: true,
    message: '请输入商品关键字',
    trigger: 'blur'
  }],
  unitName: [{
    required: true,
    message: '请输入单位',
    trigger: 'blur'
  }],
  supplierId: [{
    required: true,
    message: '请选择供应商',
    trigger: 'blur'
  }],
  isShow: [{
    required: true,
    message: '请选择商品状态',
    trigger: 'blur'
  }],
  brandIdObj: [{
    required: true,
    message: '请选择品牌',
    trigger: 'blur'
  }],
  tempId: [{
    required: true,
    message: '请选择运费模板',
    trigger: 'change'
  }],
  taxKey: [{
    required: true,
    message: '请选择进项税率',
    trigger: 'change'
  }],
  image: [{
    required: true,
    message: '请上传商品图',
    trigger: 'change'
  }],
  fuCardId: [{
    required: true,
    message: '请选择福卡',
    trigger: 'change'
  }],
  cardImage: [{
    required: true,
    message: '请上传卡片样式',
    trigger: 'change'
  }],
  // sliderImages: [{ required: true, message: '请上传商品轮播图', type: 'array', trigger: 'change' }],
  deliveryTimeOther: [{
    trigger: 'change'
  }, {
    pattern: /^-?\d+(\.\d+)?$/,
    message: '时间必须为数字值'
  }]
  // selectRule:[{ required: true, message: '请选择规格', trigger: 'change' }],
  // attrValue:[{ required: true, message: '请完善商品属性', trigger: 'change' }],
  // customerId: [{ required: true, message: '请选择分销商', trigger: 'change' }],
};
function createCouponSkuRules(vm) {
  var requireCouponImageWhenStored = function requireCouponImageWhenStored(label) {
    return {
      validator: function validator(_rule, value, callback) {
        var _vm$couponSkuInfo;
        var cpStatus = vm === null || vm === void 0 ? void 0 : (_vm$couponSkuInfo = vm.couponSkuInfo) === null || _vm$couponSkuInfo === void 0 ? void 0 : _vm$couponSkuInfo.cpStatus;
        if (cpStatus !== 3) {
          callback();
          return;
        }
        var isEmptyArray = Array.isArray(value) && value.length === 0;
        if (value === null || value === undefined || value === '' || isEmptyArray) {
          callback(new Error("\u91C7\u9500\u72B6\u6001\u4E3A\u5DF2\u5165\u5E93\u65F6\uFF0C\u8BF7\u4E0A\u4F20".concat(label)));
          return;
        }
        callback();
      },
      trigger: 'blur'
    };
  };
  var requireText = function requireText(label) {
    return {
      required: true,
      validator: function validator(_rule, value, callback) {
        if (value === null || value === undefined || String(value).trim() === '') {
          callback(new Error("\u8BF7\u8F93\u5165".concat(label)));
          return;
        }
        callback();
      },
      trigger: 'blur'
    };
  };
  var requireNumber = function requireNumber(label) {
    return {
      required: true,
      validator: function validator(_rule, value, callback) {
        if (value === null || value === undefined || value === '') {
          callback(new Error("\u8BF7\u8F93\u5165".concat(label)));
          return;
        }
        callback();
      },
      trigger: 'blur'
    };
  };
  var requireSelect = function requireSelect(label) {
    return {
      required: true,
      validator: function validator(_rule, value, callback) {
        if (value === null || value === undefined || value === '') {
          callback(new Error("\u8BF7\u9009\u62E9".concat(label)));
          return;
        }
        callback();
      },
      trigger: 'change'
    };
  };
  return {
    couponId: [requireSelect('优惠券名称')],
    suk: [requireText('规格名称')],
    skuName: [requireText('sku名称')],
    skuCode: [requireText('sku编码')],
    otPrice: [requireNumber('原价')],
    supplyPrice: [requireNumber('供货价')],
    guidePrice: [requireNumber('指导价')],
    defaultPrice: [requireNumber('默认售价')],
    stock: [requireNumber('库存数量')],
    stockWarning: [requireNumber('库存预警')],
    cpStatus: [requireSelect('采销状态')],
    attrImage: [requireCouponImageWhenStored('规格图片')],
    image: [requireCouponImageWhenStored('主图')],
    listStatus: [{
      required: true,
      validator: function validator(_rule, value, callback) {
        if (value === null || value === undefined || value === '') {
          callback(new Error('请选择上下架状态'));
          return;
        }
        if (value === 1 && vm && vm.couponSkuInfo && vm.couponSkuInfo.cpStatus !== 3) {
          callback(new Error('只有已入库才能上架'));
          return;
        }
        callback();
      },
      trigger: 'blur'
    }],
    barCode: [requireText('条形码')]
  };
}
var props = exports.props = {
  children: 'child',
  label: 'name',
  value: 'id'
};
var comData = exports.comData = _vue.default.observable({
  cateIdsOption: [],
  // 商品分类
  showCateIdOption: [],
  // 展示分类
  suppliers: [],
  // 供应商
  brandList: [],
  // 品牌
  shippingList: [],
  // 运费模板
  citys: [],
  //产地
  ruleList: [],
  //规格模板
  goodsLabelEnum: [],
  // 商品标签
  channelLists: [],
  customersList: [],
  //分销商
  productAttrEnum: [],
  // 商品属性
  taxKeyEnum: [],
  // 进项税率
  fuCardList: [] //福卡列表
});

/**
 *  获取分类
 * @param {*} type  1：商品分类 8：展示分类
 */
function getCategorySelect(_x) {
  return _getCategorySelect.apply(this, arguments);
}
/**
 * 限制商品分类只能选择开启的
 */
function _getCategorySelect() {
  _getCategorySelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type) {
    var res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return (0, _store.categoryApi)({
            status: -1,
            type: type
          });
        case 1:
          res = _context.v;
          _t = type;
          _context.n = _t === 1 ? 2 : _t === 8 ? 3 : 4;
          break;
        case 2:
          comData.cateIdsOption = addDisabled(res);
          return _context.a(3, 5);
        case 3:
          comData.showCateIdOption = addDisabled(res);
          return _context.a(3, 5);
        case 4:
          return _context.a(3, 5);
        case 5:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _getCategorySelect.apply(this, arguments);
}
function addDisabled() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var list = [];
  arr && arr.length && arr.forEach(function (e, index) {
    var e_new = _objectSpread(_objectSpread({}, e), {}, {
      disabled: !e.status
    });
    if (e.child) {
      var childList = addDisabled(e.child);
      e_new = _objectSpread(_objectSpread({}, e_new), {}, {
        child: childList
      });
    }
    list.push(e_new);
  });
  return list;
}

/**
 * 获取供应商
 */
function getSupplierList(_x2, _x3) {
  return _getSupplierList.apply(this, arguments);
}
/**
 * 获取福卡列表
 */
function _getSupplierList() {
  _getSupplierList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(keyword, productType) {
    var params;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          params = {
            keyword: keyword
          };
          productType && (params['productType'] = productType);
          (0, _store.getSupplierApi)(params).then(function (res) {
            comData.suppliers = res || [];
          });
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _getSupplierList.apply(this, arguments);
}
function getFuCardList() {
  return _getFuCardList.apply(this, arguments);
}
function _getFuCardList() {
  _getFuCardList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var _this = this;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          // 获取卡片选项
          fudouActiveApi.selectCard('').then(function (res) {
            comData.fuCardList = res.map(function (item) {
              return {
                value: item.id,
                label: item.card_name
              };
            });
          }).catch(function (err) {
            _this.$message.error('获取卡片列表失败');
          });
        case 1:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _getFuCardList.apply(this, arguments);
}
function getBrandList(_x4, _x5) {
  return _getBrandList.apply(this, arguments);
}
/**
 *  获取品牌
 */
function _getBrandList() {
  _getBrandList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(keyword, supplierId) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          getBrandLists(keyword, supplierId).then(function (res) {
            if (!res.length) {
              return getBrandLists('', '');
            }
          });
        case 1:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _getBrandList.apply(this, arguments);
}
function getBrandLists(_x6, _x7) {
  return _getBrandLists.apply(this, arguments);
}
/**
 *  获取运费模板
 */
function _getBrandLists() {
  _getBrandLists = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(keyword, supplierId) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, new Promise(function (resolve, reject) {
            var params = {
              keyword: keyword
            };
            supplierId && (params['supplierId'] = supplierId);
            (0, _store.getBrandrApi)(params).then(function (res) {
              comData.brandList = res || [];
              resolve(res);
            });
          }));
      }
    }, _callee5);
  }));
  return _getBrandLists.apply(this, arguments);
}
function getShippingList(_x8) {
  return _getShippingList.apply(this, arguments);
}
/**
 * 获取产地
 */
function _getShippingList() {
  _getShippingList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(params) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          (0, _logistics.shippingTemplatesList)(params).then(function (res) {
            comData.shippingList = res.list || [];
          });
        case 1:
          return _context6.a(2);
      }
    }, _callee6);
  }));
  return _getShippingList.apply(this, arguments);
}
function getPlaceList() {
  return _getPlaceList.apply(this, arguments);
}
/**
 * 获取规格
 */
function _getPlaceList() {
  _getPlaceList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          (0, _store.getCityApi)().then(function (res) {
            comData.citys = res;
          });
        case 1:
          return _context7.a(2);
      }
    }, _callee7);
  }));
  return _getPlaceList.apply(this, arguments);
}
function getRule(_x9) {
  return _getRule.apply(this, arguments);
}
/**
 * 获取商品标签
 */
function _getRule() {
  _getRule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(params) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          (0, _store.templateListApi)(params).then(function (res) {
            var _ref = res || {},
              _ref$list = _ref.list,
              list = _ref$list === void 0 ? [] : _ref$list;
            var lists = list.map(function (j) {
              var _ref2 = j || {},
                ruleValue = _ref2.ruleValue;
              return _objectSpread(_objectSpread({}, j), {}, {
                ruleValue: ruleValue && JSON.parse(ruleValue)
              });
            });
            comData.ruleList = lists || [];
          });
        case 1:
          return _context8.a(2);
      }
    }, _callee8);
  }));
  return _getRule.apply(this, arguments);
}
function getlabelList(_x0) {
  return _getlabelList.apply(this, arguments);
}
function _getlabelList() {
  _getlabelList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(params) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          (0, _store.getLabelApi)(params).then(function (res) {
            comData.goodsLabelEnum = res || [];
          });
        case 1:
          return _context9.a(2);
      }
    }, _callee9);
  }));
  return _getlabelList.apply(this, arguments);
}
function getChannelList(_x1) {
  return _getChannelList.apply(this, arguments);
}
/**
 * 获取分销商
 */
function _getChannelList() {
  _getChannelList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(params) {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          (0, _fudouActiveApi.selectChannel)(params).then(function (res) {
            comData.channelLists = res || [];
          });
        case 1:
          return _context0.a(2);
      }
    }, _callee0);
  }));
  return _getChannelList.apply(this, arguments);
}
function getCustomers(_x10) {
  return _getCustomers.apply(this, arguments);
}
/**
 * 获取商品属性
 */
function _getCustomers() {
  _getCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(params) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          (0, _api.getCustomersApi)(params).then(function (res) {
            comData.customersList = res || [];
          });
        case 1:
          return _context1.a(2);
      }
    }, _callee1);
  }));
  return _getCustomers.apply(this, arguments);
}
function getProductAttrEnum(_x11) {
  return _getProductAttrEnum.apply(this, arguments);
}
/**
 * 进项税率
 */
function _getProductAttrEnum() {
  _getProductAttrEnum = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(params) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          (0, _componentsApi.dictionaryGetListApi)(params).then(function (res) {
            comData.productAttrEnum = res || [];
          });
        case 1:
          return _context10.a(2);
      }
    }, _callee10);
  }));
  return _getProductAttrEnum.apply(this, arguments);
}
function getTaxKeyEnumEnum(_x12) {
  return _getTaxKeyEnumEnum.apply(this, arguments);
}
function _getTaxKeyEnumEnum() {
  _getTaxKeyEnumEnum = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(params) {
    var res, _t2;
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.p = _context11.n) {
        case 0:
          _context11.p = 0;
          _context11.n = 1;
          return (0, _componentsApi.dictionaryGetListApi)(params);
        case 1:
          res = _context11.v;
          comData.taxKeyEnum = res || [];
          _context11.n = 3;
          break;
        case 2:
          _context11.p = 2;
          _t2 = _context11.v;
          console.log("\u83B7\u53D6\u5546\u54C1\u5C5E\u6027\u5931\u8D25\uFF01----".concat(_t2));
        case 3:
          return _context11.a(2);
      }
    }, _callee11, null, [[0, 2]]);
  }));
  return _getTaxKeyEnumEnum.apply(this, arguments);
}
function init() {
  getCategorySelect(1);
  getCategorySelect(8);
  getSupplierList();
  getBrandList();
  getShippingList({
    page: 1,
    limit: 999
  });
  getPlaceList();
  getRule({
    page: 1,
    limit: 999,
    keywords: ''
  });
  getlabelList({
    page: 1,
    limit: 10000,
    status: 1
  });
  getChannelList();
  getCustomers();
  getProductAttrEnum({
    group: 'product_certification'
  });
  getTaxKeyEnumEnum({
    group: 'income_tax_rate'
  });
  getFuCardList();
}

/**
 * 数据验证
 */
function validate() {
  var formRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'formRef';
  return this.$refs[formRef] && this.$refs[formRef].validate();
}